import React from 'react';

interface CancelSubscriptionButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const CancelSubscriptionButton: React.FC<CancelSubscriptionButtonProps> = ({
  onClick,
  disabled,
}) => (
  <button
    type="button"
    className="billing-secondary billing-danger"
    onClick={onClick}
    disabled={disabled}
  >
    Cancel subscription
  </button>
);

export default CancelSubscriptionButton;
